export default {"src":"/_next/static/media/huawei_logo.7bf5fb54.svg","height":114,"width":112};